// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add_face {
  min-height: 80vh;
  overflow: auto;
}
.add_face::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.add_face::-webkit-scrollbar-thumb {
  background: #3b00f8;
}
.add_face::-webkit-scrollbar-track {
  background: #9d80fc;
}
@media (max-width: 600px) {
  .add_face::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .add_face::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .add_face::-webkit-scrollbar-track {
    background: white;
  }
}
.add_face .add_face_inputs {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  margin: 2vh auto;
}
.add_face .add_face_inputs input[type=file]::file-selector-button {
  background-color: #151042;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-weight: 700;
  cursor: pointer;
}
.add_face .add_face_inputs input[type=file] {
  width: 30vw;
  background-color: rgba(255, 225, 105, 0.5);
  padding: 4px;
  border-radius: 8px;
}
.add_face .add_face_inputs select {
  width: 30vw;
  padding: 4px;
  border-radius: 8px;
  height: 5vh;
}
@media (max-width: 1000px) {
  .add_face .add_face_inputs {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
  }
  .add_face .add_face_inputs select,
  .add_face .add_face_inputs input[type=file] {
    width: 95vw;
  }
}
.add_face .add_face_display {
  height: 50vh;
  border: 5px solid #151042;
  width: 30vw;
  margin: 0 auto;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 0;
}
.add_face .add_face_display .face_rec_image {
  border-radius: 8px;
  width: 100%;
  max-height: 45vh;
  max-width: 25vw;
}
.add_face .add_face_display .no_image_placeholder {
  font-size: 20rem;
  color: #151042;
}
@media (max-width: 1000px) {
  .add_face .add_face_display {
    width: 95vw;
  }
}
.add_face .add_face_btns {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  margin: 2vh auto;
}
.add_face .add_face_btns button {
  width: 15vw;
  font-weight: 700;
}
.add_face .add_face_btns .add_btn {
  background-color: #151042;
}
.add_face .add_face_btns .clear_btn {
  background-color: #ffe169;
  color: #151042;
}
@media (max-width: 1000px) {
  .add_face .add_face_btns button {
    width: 47vw;
  }
}
.add_face .alert_section {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  gap: 0;
  height: 4vh;
  margin: 1vh auto;
}
.add_face .alert_section .alert_box {
  background-color: #151042;
  color: #fff;
  font-weight: 700;
  margin: 0;
  padding: 0;
  width: 30vw;
  text-align: center;
  justify-content: center;
}
@media (max-width: 1000px) {
  .add_face .alert_section {
    width: 95vw;
  }
  .add_face .alert_section .alert_box {
    width: 95vw;
  }
}
.add_face .hikDetails {
  display: flex;
  justify-content: space-between;
  width: 25%;
  margin: 0 auto;
  background-color: #151042;
  color: #ffe169;
  padding-left: 50px;
  padding-right: 50px;
  margin-bottom: 1%;
  border-radius: 8px;
}
.add_face .hikDetails p {
  border: 3px solid #ffe169;
  border-radius: 50px;
  font-weight: bold;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/addface.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBCgBU;EDfV,cAAA;AADJ;AC4DI;EACI,YD3DgB;EC4DhB,aD5DgB;AAExB;AC6DI;EACI,mBAxDO;ADHf;AC8DI;EACI,mBAbe;AD/CvB;AAPI;ECyDA;IACI,UDzDoB;IC0DpB,WD1DoB;EAW1B;ECkDE;IACI,gBA9DA;EDcN;ECmDE;IACI,iBAbe;EDpCrB;AACF;AAfI;ECmBA,aAAA;EACA,uBDnBkB;ECoBlB,mBDpB0B;ECqB1B,mBDrBkC;ECsBlC,SDtBuC;EACnC,gBAAA;AAqBR;AApBQ;EACI,yBCFO;EDGP,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAsBZ;AAnBQ;EACI,WAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;AAqBZ;AAnBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAqBZ;AAnBQ;EAzBJ;ICmBA,aAAA;IACA,uBDMsB;ICLtB,mBDK8B;ICJ9B,sBDIsC;ICHtC,SDG8C;EA0BhD;EAzBU;;IAEI,WAAA;EA2Bd;AACF;AAvBI;EACI,YAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;ECpBJ,aAAA;EACA,uBDoBkB;ECnBlB,mBDmB0B;EClB1B,mBDkBkC;ECjBlC,MDiBuC;AA6B3C;AA5BQ;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AA8BZ;AA5BQ;EACI,gBAAA;EACA,cC/CO;AD6EnB;AA3BQ;EAlBJ;IAmBQ,WAAA;EA8BV;AACF;AA3BI;ECtCA,aAAA;EACA,uBDsCkB;ECrClB,mBDqC0B;ECpC1B,mBDoCkC;ECnClC,SDmCuC;EACnC,gBAAA;AAiCR;AAhCQ;EACI,WAAA;EACA,gBAAA;AAkCZ;AAhCQ;EACI,yBC/DO;ADiGnB;AAhCQ;EACI,yBC/DK;EDgEL,cCnEO;ADqGnB;AA/BQ;EACI;IACI,WAAA;EAiCd;AACF;AA9BI;EC3DA,aAAA;EACA,sBD2DkB;EC1DlB,mBD0DyB;ECzDzB,sBDyDiC;ECxDjC,MDwDyC;EACrC,WAAA;EACA,gBAAA;AAoCR;AAnCQ;EACI,yBCjFO;EDkFP,WCvFJ;EDwFI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AAqCZ;AAnCQ;EAdJ;IAeQ,WAAA;EAsCV;EArCU;IACI,WAAA;EAuCd;AACF;AAnCI;EACI,aAAA;EACA,8BAAA;EACA,UAAA;EACA,cAAA;EACA,yBCvGW;EDwGX,cCrGS;EDsGT,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAqCR;AAnCQ;EACI,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAqCZ","sourcesContent":["@import \"../../variables.scss\";\n\n.add_face {\n    min-height: $main-height;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitrocamBlue);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n\n    .add_face_inputs {\n        @include flex(center, center, row, 10px);\n        margin: 2vh auto;\n        input[type=\"file\"]::file-selector-button {\n            background-color: $nitrocamDarkBlue;\n            color: white;\n            padding: 10px 20px;\n            border: none;\n            border-radius: 5px;\n            font-weight: 700;\n            cursor: pointer;\n        }\n\n        input[type=\"file\"] {\n            width: 30vw;\n            background-color: rgba($nitrocamYellow, 0.5);\n            padding: 4px;\n            border-radius: 8px;\n        }\n        select {\n            width: 30vw;\n            padding: 4px;\n            border-radius: 8px;\n            height: 5vh;\n        }\n        @media (max-width: $tablet) {\n            @include flex(center, center, column, 10px);\n            select,\n            input[type=\"file\"] {\n                width: 95vw;\n            }\n        }\n    }\n\n    .add_face_display {\n        height: 50vh;\n        border: 5px solid $nitrocamDarkBlue;\n        width: 30vw;\n        margin: 0 auto;\n        border-radius: 5px;\n        @include flex(center, center, row, 0);\n        .face_rec_image {\n            border-radius: 8px;\n            width: 100%;\n            max-height: 45vh;\n            max-width: 25vw;\n        }\n        .no_image_placeholder {\n            font-size: 20rem;\n            color: $nitrocamDarkBlue;\n        }\n\n        @media (max-width: $tablet) {\n            width: 95vw;\n        }\n    }\n\n    .add_face_btns {\n        @include flex(center, center, row, 10px);\n        margin: 2vh auto;\n        button {\n            width: 15vw;\n            font-weight: 700;\n        }\n        .add_btn {\n            background-color: $nitrocamDarkBlue;\n        }\n        .clear_btn {\n            background-color: $nitrocamYellow;\n            color: $nitrocamDarkBlue;\n        }\n\n        @media (max-width: $tablet) {\n            button {\n                width: 47vw;\n            }\n        }\n    }\n    .alert_section {\n        @include flex(start, center, column, 0);\n        height: 4vh;\n        margin: 1vh auto;\n        .alert_box {\n            background-color: $nitrocamDarkBlue;\n            color: $white;\n            font-weight: 700;\n            margin: 0;\n            padding: 0;\n            width: 30vw;\n            text-align: center;\n            justify-content: center;\n        }\n        @media (max-width: $tablet) {\n            width: 95vw;\n            .alert_box {\n                width: 95vw;\n            }\n        }\n    }\n\n    .hikDetails {\n        display: flex;\n        justify-content: space-between;\n        width: 25%;\n        margin: 0 auto;\n        background-color: $nitrocamDarkBlue;\n        color: $nitrocamYellow;\n        padding-left: 50px;\n        padding-right: 50px;\n        margin-bottom: 1%;\n        border-radius: 8px;\n\n        p {\n            border: 3px solid $nitrocamYellow;\n            border-radius: 50px;\n            font-weight: bold;\n            padding: 5px;\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
